module.exports = __webpack_public_path__ + "img/38_25.5254ac3b.png";